import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { copyToClipboard$ } from 'src/app/utilities/helpers';

@Component({
  selector: 'share-link-pill',
  templateUrl: './share-link-pill.component.html',
})
export class ShareLinkPillComponent {
  @Input() link = '';
  copied = false;

  constructor(private toastr: ToastrService) {}

  onCopyClick(): void {
    copyToClipboard$(this.link).subscribe({
      next: copied => (this.copied = copied),
      error: () => this.toastr.error('Failed to copy link')
    });
  }
}
